export default {
  // Header
  "title": "Zufälliger Pokémon-Generator",
  "subtitle": "Generiere zufällige Pokémon basierend auf deinen Vorlieben",
  "home": "Startseite",
  "whichPokemonAmI": "Welches Pokémon bin ich?",
  "aboutUs": "Über uns",
  "contactUs": "Kontakt",
  "privacyPolicy": "Datenschutzerklärung",
  
  // Filters
  "filterTitle": "Filteroptionen",
  "generateButton": "Zufällige Pokémon generieren",
  "generating": "Generiere...",
  "numberOfPokemon": "Anzahl der Pokémon",
  "type": "Typ",
  "generation": "Generation",
  "minimumRarity": "Minimale Seltenheit (1-10)",
  "anyType": "Beliebiger Typ",
  "anyGeneration": "Beliebige Generation",
  "anyRarity": "Beliebige Seltenheit",
  "countingPokemon": "Zähle passende Pokémon",
  "matchingPokemonCount": "{{count}} Pokémon entsprechen deinen Filtern",
  
  // Pokemon Types
  "normal": "Normal",
  "fire": "Feuer",
  "water": "Wasser",
  "electric": "Elektro",
  "grass": "Pflanze",
  "ice": "Eis",
  "fighting": "Kampf",
  "poison": "Gift",
  "ground": "Boden",
  "flying": "Flug",
  "psychic": "Psycho",
  "bug": "Käfer",
  "rock": "Gestein",
  "ghost": "Geist",
  "dragon": "Drache",
  "dark": "Unlicht",
  "steel": "Stahl",
  "fairy": "Fee",
  
  // Generations
  "Generation I": "Generation I",
  "Generation II": "Generation II",
  "Generation III": "Generation III",
  "Generation IV": "Generation IV",
  "Generation V": "Generation V",
  "Generation VI": "Generation VI",
  "Generation VII": "Generation VII",
  "Generation VIII": "Generation VIII",
  "Generation IX": "Generation IX",
  
  // Evolution Stage
  "evolutionStage": "Entwicklungsstufe",
  "evolutionStageAll": "Alle Stufen",
  "evolutionStageFullyEvolved": "Vollständig Entwickelt",
  "evolutionStageNotFullyEvolved": "Nicht Vollständig Entwickelt",
  
  // About Section
  "aboutTitle": "Über den zufälligen Pokémon-Generator",
  
  // Section titles
  "introTitle": "Willkommen bei unserem zufälligen Pokémon-Generator",
  "howToUseTitle": "Wie man den zufälligen Pokémon-Generator benutzt",
  "benefitsTitle": "Vorteile unseres zufälligen Pokémon-Generators",
  "historyTitle": "Geschichte von Pokémon",
  "popularPokemonTitle": "Beliebte Pokémon",
  "popularGamesTitle": "Beliebte Pokémon-Spiele",
  "tradingContestsTitle": "Pokémon-Tausch und Wettbewerbe",
  "faqTitle": "Häufig gestellte Fragen",
  "conclusionTitle": "Starte noch heute dein zufälliges Pokémon-Abenteuer!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "Pokémon und Pokémon-Charakternamen sind Markenzeichen von Nintendo.",
  "linksTitle": "Nützliche Links",
  
  // About Us Page
  "aboutUsTitle": "Über uns",
  "aboutUsWhoWeAre": "Wer wir sind",
  "aboutUsWhoWeAreContent1": "Willkommen beim zufälligen Pokémon-Generator, einem von Pokémon-Enthusiasten erstellten Fan-Tool. Unsere Reise begann 2023, als eine Gruppe von Entwicklern, die sowohl Programmieren als auch Pokémon liebten, beschloss, ein nützliches Werkzeug für die Community zu erstellen.",
  "aboutUsWhoWeAreContent2": "Unser Team besteht aus Entwicklern, Designern und Content-Erstellern, die zusammenarbeiten, um Pokémon-Fans auf der ganzen Welt das bestmögliche Erlebnis zu bieten.",
  "aboutUsOurMission": "Unsere Mission",
  "aboutUsOurMissionContent1": "Wir streben danach, die Welt von Pokémon für alle zugänglicher und angenehmer zu gestalten. Unsere Tools sollen Trainern helfen, neue Pokémon zu entdecken, ausgewogene Teams zu erstellen und ihr perfektes Pokémon-Match zu finden.",
  "aboutUsOurMissionContent2": "Wir setzen uns dafür ein, ein benutzerfreundliches, genaues und unterhaltsames Erlebnis zu bieten, das die Pokémon-Franchise respektiert und gleichzeitig der Community einen Mehrwert bietet.",
  "aboutUsOurTeam": "Unser Team",
  "aboutUsOurTeamContent1": "Unser vielfältiges Team vereint Fachwissen in Webentwicklung, Pokémon-Wissen, User Experience Design und Community-Management. Uns verbindet die Liebe zu Pokémon und das Engagement, hochwertige Tools zu erstellen.",
  "aboutUsOurTeamContent2": "Jedes Teammitglied trägt mit seinen einzigartigen Fähigkeiten und Perspektiven dazu bei, den zufälligen Pokémon-Generator zum Besten zu machen.",
  "aboutUsJoinUs": "Mach mit",
  "aboutUsJoinUsContent": "Wir suchen stets nach leidenschaftlichen Personen, die unserer Community beitreten möchten. Ob du Entwickler, Designer, Pokémon-Experte oder begeisterter Nutzer bist, dein Feedback und deine Beiträge sind willkommen.",
  
  // Contact Us Page
  "contactUsTitle": "Kontakt",
  "contactUsGetInTouch": "Kontaktiere uns",
  "contactUsGetInTouchContent": "Hast du Fragen, Vorschläge oder Feedback zum zufälligen Pokémon-Generator? Wir würden gerne von dir hören! Hier sind die Möglichkeiten, wie du unser Team erreichen kannst.",
  "contactUsEmail": "E-Mail",
  "contactUsPhone": "Telefon",
  "contactUsAddress": "Adresse",
  "contactUsHelpSupport": "Hilfe & Support",
  "contactUsHelpSupportContent": "Benötigst du Hilfe bei der Nutzung unserer Tools oder hast du ein Problem festgestellt? Unser Support-Team ist für dich da.",
  "contactUsFAQ": "Häufig gestellte Fragen",
  "contactUsFAQContent": "Bevor du uns kontaktierst, schau dir unseren FAQ-Bereich an, der viele häufige Fragen und Probleme behandelt.",
  "contactUsBugReport": "Fehler melden",
  "contactUsBugReportContent": "Wenn du einen Fehler oder ein technisches Problem gefunden hast, informiere uns bitte per E-Mail mit 'FEHLERBERICHT' in der Betreffzeile.",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "Datenschutzerklärung",
  "privacyPolicyIntro": "Einführung",
  "privacyPolicyIntroContent": "Beim zufälligen Pokémon-Generator respektieren wir deine Privatsphäre und verpflichten uns zum Schutz deiner persönlichen Daten. Diese Datenschutzerklärung erläutert, wie wir deine Informationen sammeln, verwenden und schützen, wenn du unsere Website nutzt.",
  "privacyPolicyInformation": "Informationen, die wir sammeln",
  "privacyPolicyInformationContent": "Wir sammeln minimale Informationen, um unsere Dienste bereitzustellen und zu verbessern. Dies kann Folgendes umfassen:",
  "privacyPolicyInformationItem1": "Nutzungsdaten (wie besuchte Seiten, auf der Website verbrachte Zeit und genutzte Funktionen)",
  "privacyPolicyInformationItem2": "Geräteinformationen (Browsertyp, Betriebssystem und Bildschirmauflösung)",
  "privacyPolicyInformationItem3": "IP-Adresse und ungefährer Standort (nur auf Länderebene)",
  "privacyPolicyCookies": "Cookies und ähnliche Technologien",
  "privacyPolicyCookiesContent": "Wir verwenden Cookies, um deine Erfahrung auf unserer Website zu verbessern. Diese kleinen Textdateien ermöglichen es uns, deine Präferenzen zu speichern und die Nutzung unserer Seite zu analysieren. Du kannst Cookies über die Einstellungen deines Browsers kontrollieren.",
  "privacyPolicyThirdParty": "Dienste von Drittanbietern",
  "privacyPolicyThirdPartyContent": "Unsere Website kann Dienste von Drittanbietern wie Analyseanbieter und Content-Delivery-Netzwerke nutzen. Diese Dienste können Informationen über deine Nutzung unserer Website sammeln. Wir stellen sicher, dass alle Drittanbieter deine Privatsphäre respektieren und die Daten angemessen behandeln.",
  "privacyPolicySecurity": "Datensicherheit",
  "privacyPolicySecurityContent": "Wir implementieren angemessene Sicherheitsmaßnahmen, um deine Informationen vor unbefugtem Zugriff, Änderung oder Offenlegung zu schützen. Allerdings ist keine Übertragung über das Internet zu 100% sicher, daher können wir keine absolute Sicherheit garantieren.",
  "privacyPolicyChanges": "Änderungen dieser Richtlinie",
  "privacyPolicyChangesContent": "Wir können unsere Datenschutzerklärung gelegentlich aktualisieren. Wir informieren dich über Änderungen, indem wir die neue Datenschutzerklärung auf dieser Seite veröffentlichen und das Datum der 'letzten Aktualisierung' aktualisieren.",
  "privacyPolicyContact": "Kontaktiere uns",
  "privacyPolicyContactContent": "Wenn du Fragen zu dieser Datenschutzerklärung hast, kontaktiere uns bitte über die auf unserer Kontaktseite angegebenen Informationen.",
  "privacyPolicyLastUpdated": "Zuletzt aktualisiert",

  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "Welches Pokémon bin ich?",
  "whichPokemonAmISubtitle": "Finde heraus, welches Pokémon am besten zu dir passt",
  "enterYourName": "Gib deinen Namen ein",
  "namePlaceholder": "Dein Name",
  "enterFavoriteColor": "Wähle deine Lieblingsfarbe",
  "enterBirthMonth": "Wähle deinen Geburtsmonat",
  "selectBirthMonth": "Geburtsmonat wählen",
  "enterPersonalityTrait": "Wähle einen Persönlichkeitszug",
  "selectPersonalityTrait": "Persönlichkeitszug wählen",
  "findMyPokemon": "Mein Pokémon finden",
  "calculating": "Berechne...",
  "yourPokemonIs": "Dein Pokémon ist",
  "pokemonDescription": "Beschreibung",
  "personalityMatch": "Persönlichkeits-Übereinstimmung",
  "yourCompatibility": "Deine Kompatibilität",
  "downloadImage": "Bild herunterladen",
  "shareResult": "Ergebnis teilen",
  "tryAgain": "Nochmal versuchen",
  "results": "Ergebnisse",
  "aboutTool": "Über dieses Tool",
  "howToUse": "Anwendung",
  "benefits": "Vorteile",
  "faq": "FAQ",
  "conclusion": "Fazit",
  
  // Error messages
  "nameRequired": "Name ist erforderlich",
  "colorRequired": "Bitte wähle eine Farbe",
  "monthRequired": "Bitte wähle einen Monat",
  "traitRequired": "Bitte wähle einen Persönlichkeitszug",
  
  // Months
  "january": "Januar",
  "february": "Februar",
  "march": "März",
  "april": "April",
  "may": "Mai",
  "june": "Juni",
  "july": "Juli",
  "august": "August",
  "september": "September",
  "october": "Oktober",
  "november": "November",
  "december": "Dezember",
  
  // Personality Traits
  "brave": "Mutig",
  "calm": "Ruhig",
  "timid": "Schüchtern",
  "jolly": "Fröhlich",
  "quiet": "Still",
  "hasty": "Hastig",
  "careful": "Vorsichtig",
  "lonely": "Einsam",
  "bold": "Kühn",
  "relaxed": "Entspannt",
  "impish": "Schelmisch",
  "modest": "Bescheiden",
  
  // Size matching feature
  "enterHeightWeight": "Gib deine Größe und dein Gewicht ein — finde heraus, welches Pokémon dir ähnelt!",
  "whichPokemonMatchesSize": "Welches Pokémon passt zu deiner Größe?",
  "youAreMostLike": "Du ähnelst am meisten",
  "nameLabel": "Name",
  "heightLabel": "Größe",
  "weightLabel": "Gewicht",
  "heightValid": "Bitte gib eine gültige Größe ein (1-300 cm)",
  "weightValid": "Bitte gib ein gültiges Gewicht ein (1-500 kg)",
  "enterDetails": "Deine Details eingeben",
  "finding": "Suche...",
  "errorFinding": "Fehler bei der Suche nach deinem Pokémon",
  "matchResult": "Das Pokémon von {{name}} ist...",
  "similarityScore": "Ähnlichkeitswert",
  "downloadStarted": "Bild wird vorbereitet...",
  "downloadComplete": "Bild erfolgreich heruntergeladen!",
  "shareText": "Ich habe entdeckt, dass ich {{pokemon}} bin! Finde heraus, welches Pokémon du bist!",
  "madeBy": "Erstellt von",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to German)
  "pokemonRandomizerPageAboutTitle": "Entdecken Sie das ultimative Pokémon-Randomizer-Erlebnis",
  "pokemonRandomizer_whatIsItTitle": "Was genau ist ein Pokémon-Randomizer?",
  "pokemonRandomizer_featuresTitle": "Hauptmerkmale unseres Pokémon-Randomizer-Tools",
  "pokemonRandomizer_whyUseTitle": "Warum ein Abenteuer mit einem Pokémon-Randomizer beginnen?",
  "pokemonRandomizer_gettingStartedTitle": "Erste Schritte: Ihr erster Pokémon-Randomizer-Durchlauf",
  "pokemonRandomizer_faqTitle": "Pokémon-Randomizer: Häufig gestellte Fragen",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to German)
  "pokemonRandomizerPageH1": "Pokémon-Randomizer",
  "pokemonRandomizerPageSubtitle": "Erstellen Sie einzigartige Pokémon-Erlebnisse mit unserem fortschrittlichen Randomizer-Tool.",

  // Sub-Footer
  subFooterToolsTitle: "Werkzeuge",
  subFooterRandomPokemonGeneratorLink: "Zufälliger Pokémon-Generator",
  subFooterPokemonRandomizerLink: "Pokémon-Randomizer",
  subFooterWhichPokemonAmILink: "Welches Pokémon bin ich?",

  subFooterPokemonDatabaseTitle: "Pokémon-Datenbank",
  subFooterPokedexLink: "Pokédex (Demnächst)",
  subFooterTypeChartsLink: "Typentabellen (Demnächst)",
  subFooterMoveListLink: "Attackenliste (Demnächst)",

  subFooterBlogTitle: "Blog",
  subFooterLatestArticlesLink: "Neueste Artikel (Demnächst)",
  subFooterGuidesTutorialsLink: "Anleitungen & Tutorials (Demnächst)"
};
